import { TASK } from 'fixtures/api'
import { getAllList } from 'services/cmsService'

const getCollabByType = (type, id) => {
  return async dispatch => {
    let data = []
    let newData = await getAllList(TASK[type](id, 'collab'))
    if (newData) {
      data = newData
    }

    dispatch({
      type: `GET_COLLAB_${type}`,
      payload: data
    })
  }
}

export { getCollabByType }
